/* eslint-disable react/display-name */
import React, {useEffect, useRef} from 'react';
import {Route, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

import Map from '../map';
import TimelineContainer from '../timeline/TimelineContainer';
import Home from '../home';
import Outro from '../outro';
import Navigation from '../navigation';

import {
  LayoutWrapper,
  MainWrapperInner,
  MainWrapper,
  MobilNavWrapper,
  MobileContentWrapper,
  DesktopSideWrapper,
} from './Layout.styles';
import useStore from '../../hooks/useStore';
import ProjectDescription from '../map/ProjectDescription';
import Story from '../timeline/Story';

const LayoutDisplay = ({location}) => {
  const scrollRef = useRef();

  const {state} = useStore();
  const {activeProject, activeLayer, activeChart, lang, data} = state;

  const position = activeProject && activeProject.position;

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'en' ? 'ltr' : 'rtl';
    if (lang === 'ar') {
      document.body.scrollLeft = document.body.scrollWidth * -1;
    }
  }, [lang]);

  useEffect(() => {
    document.body.scrollTop = 0;
  }, [location]);

  useEffect(() => {
    const mapWidth = 1080;
    const mapHeight = 1540;
    const iconCenter = 50 / 2;
    const {scrollWidth, scrollHeight} = document.body;

    if (scrollRef.current && position) {
      console.log(position);
      const leftPosition =
        lang === 'en'
          ? ((position.x / mapWidth) * scrollWidth) / 2 - iconCenter
          : (-1 *
              (((mapWidth - position.x) / mapWidth) *
                document.body.scrollWidth)) /
              2 +
            iconCenter;
      document.body.scrollTo({
        left: leftPosition,
        top: (position.y / mapHeight) * scrollHeight - 176 - iconCenter,
        behavior: 'smooth',
      });
    }
  }, [activeProject, position, lang]);

  const isFront = location.pathname === '/';
  const path = location.pathname.split('/');
  const layer = (path[1] === 'map' && path[2]) || 'surface';
  const page = path[1] || 'front';

  return (
    <LayoutWrapper className={isFront ? 'front' : page}>
      <DesktopSideWrapper className='desktop-side'>
        <Navigation />
        <Route exact path='/map/:layer?'>
          <ProjectDescription
            activeLayer={activeLayer}
            activeProject={activeProject}
            data={data}
            lang={lang}
          />
        </Route>
        <Route exact path='/timeline/:year?'>
          <Story lang={lang} activeChart={activeChart} />
        </Route>
      </DesktopSideWrapper>
      <MobilNavWrapper className='mobile-nav'>
        <Navigation />
      </MobilNavWrapper>
      <MobileContentWrapper className='mobile-content'>
        <Route exact path='/map/:layer?'>
          <ProjectDescription
            activeLayer={activeLayer}
            activeProject={activeProject}
            data={data}
            lang={lang}
          />
        </Route>
        <Route exact path='/timeline/:year?'>
          <Story lang={lang} activeChart={activeChart} />
        </Route>
      </MobileContentWrapper>
      <MainWrapper layer={layer} ref={scrollRef}>
        <MainWrapperInner layer={layer}>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route exact path='/map/:layer?'>
            <Map />
          </Route>
          <Route exact path='/timeline/:year?'>
            <TimelineContainer />
          </Route>
          <Route exact path='/outro'>
            <Outro />
          </Route>
        </MainWrapperInner>
      </MainWrapper>
    </LayoutWrapper>
  );
};

LayoutDisplay.propTypes = {
  active: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onMouseMove: PropTypes.func,
  mainRef: PropTypes.object,
  location: PropTypes.object,
};
export default withRouter(LayoutDisplay);
